/**
 * Utility to check if bulk transactions mode is enabled for the current company
 * Used to conditionally skip certain API calls when in bulk transactions mode
 */

export function isBulkTransactionsEnabled() {
  const configCompanyIds = process.env.VUE_APP_BULK_TRANSACTIONS_COMPANY_ID;
  if (!configCompanyIds) return false;
  
  // Get current company ID from localStorage
  const currentCompanyId = localStorage.getItem('currentCompanyId');
  if (!currentCompanyId) return false;
  
  // Split the comma-separated list and check if current ID is in the list
  const companyIdList = configCompanyIds.split(',').map(id => id.trim());
  return companyIdList.includes(currentCompanyId);
}
